export const storage = ()=>({
     save : (version)=>localStorage.setItem('versionStorage',version) ,
     get  : ()=> localStorage.getItem('versionStorage') ,
     getItem : (name)=>localStorage.getItem(name),
     setItem : (name,value) => localStorage.setItem(name,value),
     removeItem : (name) => localStorage.removeItem(name)
})